<template>
  <div class="main-container">
    <Header />

    <Breadcrumb :items="items" title="درباره ما" />

    <AboutSectionThree :data="pageData" />

    <!-- <Policy :policyData="data.policy" /> -->

    <!-- <Experience :experience="data.experience" /> -->

    <!-- <FunFact /> -->

    <TeamMember :teamData="getOurTeam" />

    <!-- <Testimonial /> -->

    <!-- <BrandCarousel addClass="grey-bg" /> -->

    <Footer />

    <OffCanvasMobileMenu />

    <!-- back to top start -->
    <back-to-top class="scroll-top" bottom="60px">
      <i class="ion-android-arrow-up"></i>
    </back-to-top>
    <!-- back to top end -->
  </div>
</template>

<script>
import Header from "@/components/Header"
import Breadcrumb from "../components/Breadcrumb"
import AboutSectionThree from "../components/sections/AboutSectionThree"
import Policy from "../components/Policy"
import Experience from "../components/Experience"
import FunFact from "../components/FunFact"
import TeamMember from "../components/sections/TeamMember"
import Testimonial from "../components/Testimonial"
import BrandCarousel from "../components/BrandCarousel"
import Footer from "../components/Footer"
import OffCanvasMobileMenu from "@/components/OffCanvasMobileMenu"
import { PageService } from "@/store/services/page.service.js"

import data from "../data/about.json"
import { ourTeamStore } from "@/store/Modules/ourTeam.js"
import { mapState } from "pinia"
import { mapStores } from "pinia"
import { mapActions } from "pinia"

export default {
  components: {
    Header,
    Breadcrumb,
    AboutSectionThree,
    Policy,
    Experience,
    FunFact,
    TeamMember,
    Testimonial,
    BrandCarousel,
    Footer,
    OffCanvasMobileMenu,
  },
  data() {
    return {
      data,
      pageData: {},
      metaTitle: "",
      metaDescripton: "",
      items: [
        {
          text: "خانه",
          to: "/",
        },
        {
          text: "درباره ما",
          active: true,
        },
      ],
    }
  },
  computed: {
    ...mapState(ourTeamStore, ["getOurTeam"]),
  },
  methods: {
    ...mapActions(ourTeamStore, ["getOurTeamAction"]),
  },
  mounted() {
    this.getOurTeamAction()
    this.pageData = PageService.showByTitle("about").then(({ data }) => {
      this.pageData = data
      this.metaTitle = data.extras.meta_title
      this.metaDescripton = data.extras.meta_description
    })
  },
  metaInfo() {
    return {
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.metaDescripton,
        },
        {
          vmid: "title",
          name: "title",
          content: this.metaTitle,
        },
      ],
    }
  },
}
</script>
